//import * as CONST from '@/constants.js'
/* global SimplifyCommerce */
import axios from '@/utils/axios_iface'
import md5 from 'md5'
import db from '@/lib/IndexedDB'
import Availability from '@/helpers/Availability'
import * as utils from '@/utils/main_utils'
import * as CONST from '@/constants.js'

export default {
  state: {
    cardToken: undefined,
    selectedPaymentMethod: 'COD',
    isSaveCard: undefined,
    checkSavedCardStatus: undefined,
    // eslint-disable-next-line no-undef
    simplifyPublicApiKey: process.env.VUE_APP_SIMPLIFY_KEY,
    cardModel: {
      expMonth: '01',
      expYear: new Date()
        .getFullYear()
        .toString()
        .substr(-2),
      cvc: '',
      number: '',
      name: '',
    },
    cardErrors: {
      expMonth: '',
      expYear: '',
      cvc: '',
      number: '',
      name: '',
    },
    currentCard: undefined,
    cashbackOnTransaction: undefined,
    loyalty_information: { msg: '', amount: 0 },
    user_change_loyalty: 0,
    guestCheckout: false,
    guestInfo: {},
    couponCode: '',
    couponDiscount: undefined,
  },
  getters: {
    coupon_code: state => state.couponCode,
    coupon_discount: state => state.couponDiscount,
    guest_info: state => state.guestInfo,
    guest_checkout: state => state.guestCheckout,
    get_card_errors: state => {
      if (!Object.keys(state.cardErrors).length) {
        return false
      }
      return state.cardErrors
    },
    loyalty_validation_information: state => state.loyalty_information,
    customer_saved_credit_cards: (state, getters) =>
      getters.customer_credit_cards,

    selected_payment_method: state => state.selectedPaymentMethod,

    payment_params: (state, getters) => amount => {
      let payments = []

      const paymentParams = {
        entity_id: '',
        name: '',
        collected: amount,
        param1: '',
        param2: amount,
        param3: '',
      }

      if (getters.loyalty_spent) {
        let params = { ...paymentParams }

        params.param1 = getters.customer_current_loyalty_card._id
        params.param2 = getters.loyalty_spent
        params.collected = getters.loyalty_spent
        params.param3 = getters.customer_current_loyalty_card.loyalty_card_code
        const paymentType = getters.all_payment_types.find(
          paymentType =>
            paymentType.type ===
            (getters.domainBasedBrand ? 'loyalty' : 'go_order_loyalty')
        )
        params.entity_id = paymentType._id
        params.name = paymentType.name
        payments.push(params)
      }

      if (getters.payment_needed) {
        let params = { ...paymentParams }
        params.collected = amount - getters.loyalty_spent
        params.param2 = amount - getters.loyalty_spent

        if (state.selectedPaymentMethod == 'COD') {
          const paymentType = getters.all_payment_types.find(
            paymentType => paymentType.type === 'cash'
          )
          if (!paymentType) {
            return false
          }
          params.entity_id = paymentType._id
          params.name = paymentType.name
        } else {
          const paymentType = getters.all_payment_types.find(
            paymentType => paymentType.type === 'online'
          )
          if (!paymentType) {
            return false
          }
          params.entity_id = paymentType._id
          params.name = paymentType.name
          if (state.selectedPaymentMethod == 'creditcard') {
            params.param1 = state.cardToken
            if (state.isSaveCard && !state.checkSavedCardStatus) {
              let card = getters.customer_saved_credit_cards.find(
                card => card.card_id == state.currentCard.card_id
              )
              params.param1 = card.customer_id
              params.param4 = 'card'
            }
          } else if (state.selectedPaymentMethod.match('savedcard.')) {
            let makeRegex = /savedcard./gi
            var cardId = state.selectedPaymentMethod.replace(makeRegex, '')
            var card = getters.customer_saved_credit_cards.find(
              card => card.card_id == cardId
            )
            params.param1 = card.customer_id
            params.param4 = 'card'
          }
        }

        payments.push(params)
      }
      return payments
    },
    max_loyalty_spent: (state, getters) => {
      let order_total = getters.order_total
      let loyalty_amount = getters.max_spent_loyalty.points
      let max_loyalty_apply =
        loyalty_amount >= order_total ? order_total : loyalty_amount
      if (!state.cashbackOnTransaction) return 0
      if (getters.currentBrand.min_order > order_total) return 0
      return max_loyalty_apply
    },
    loyalty_spent: (state, getters) => {
      let order_total = getters.order_total
      if (!state.cashbackOnTransaction) return 0
      if (!getters.domainBasedBrand) {
        if (state.user_change_loyalty) {
          return parseFloat(state.user_change_loyalty) > parseFloat(order_total)
            ? order_total
            : parseFloat(state.user_change_loyalty)
        } else return 0
      } else {
        // order_total = getters.exchange_price(order_total)
        let loyalty_amount = getters.max_spent_loyalty.points
        let max_loyalty_apply =
          loyalty_amount >= order_total ? order_total : loyalty_amount
        if (state.user_change_loyalty) {
          return parseFloat(state.user_change_loyalty) >
            parseFloat(max_loyalty_apply)
            ? max_loyalty_apply
            : parseFloat(state.user_change_loyalty)
        }
        if (getters.currentBrand.min_order > order_total) return 0
        return max_loyalty_apply
      }

      /*if (getters.max_spent_loyalty.amount >= getters.order_total) {
        return getters.order_total
      } else {
        return getters.cashback_balance
      }*/
    },
    payment_needed: (state, getters) => {
      if (!getters.loyalty_spent) return true
      if (getters.loyalty_spent < getters.order_total) return true
      return false
    },
  },
  actions: {
    doPostCheckout({ commit }) {
      commit('SET_GUEST_CHECKOUT', false)
    },
    async validateCheckout({ getters, dispatch }) {
      if (this.order_type === CONST.ORDER_TYPE_ONLINE) {
        if (getters.guest_checkout) {
          //do something here
        } else {
          let error = getters._T('Please provide Delivery Address')
          if (!getters.customer_address) {
            dispatch('showNotification', {
              text: error,
              status: 'error',
            })
            return Promise.reject(error)
          }
        }

        if (!getters.storeDAforCustomerAddress) {
          let error = getters._T(
            `Sorry! Store doesn't serve to selected address`
          )
          dispatch('showNotification', {
            text: error,
            status: 'error',
          })
          return Promise.reject(error)
        }
      }

      if (
        getters.min_order_value &&
        //getters.min_order_value > getters.cart_net_sub_total
        getters.min_order_value > getters.cart_sub_total
      ) {
        let error = getters._T(
          `Minimum item total '${getters.currentStore.currency} ${getters.min_order_value}' is required to place the order `
        )
        dispatch('showNotification', {
          text: error,
          status: 'error',
        })
        return Promise.reject(error)
      }

      return Promise.resolve()
    },
    async validatePayments({ state, dispatch, getters }) {
      if (getters.payment_needed) {
        if (!state.selectedPaymentMethod) {
          let error = getters._T('Please select payment method')
          dispatch('showNotification', {
            text: error,
            status: 'error',
          })
          return Promise.reject(error)
        }

        if (state.selectedPaymentMethod == 'creditcard') {
          dispatch('validateCard')
          if (getters.get_card_errors) {
            let error = getters._T('Please provide credit card information')
            dispatch('showNotification', {
              text: error,
              status: 'error',
            })
            return Promise.reject(error)
          }
        }
      }
    },
    async setPayment({ state, dispatch, getters }) {
      if (getters.payment_needed) {
        if (state.selectedPaymentMethod == 'creditcard') {
          return dispatch('createSimplifyCardToken')
        }
      }
      return Promise.resolve()
    },
    validateCard({ state, getters, commit }) {
      commit('CLEAR_CARD_ERRORS')
      let errors = {}
      if (!state.cardModel.number) {
        errors['number'] = getters._T('Please enter card number')
      } else if (
        state.cardModel.number.replace(/-/g, '').replace(/_/g, '').length < 16
      ) {
        errors['number'] = getters._T('Please enter full card number')
      }
      if (!state.cardModel.cvc) {
        errors['cvc'] = getters._T('Please enter card cvc')
      } else if (state.cardModel.cvc.toString().length < 3) {
        errors['cvc'] = getters._T('Please enter full cvc number')
      }
      if (!state.cardModel.expMonth) {
        errors['expMonth'] = getters._T('Please select card expiry month')
      }
      if (!state.cardModel.expYear) {
        errors['expYear'] = getters._T('Please select card expiry year')
      }
      if (!state.cardModel.name) {
        errors['name'] = getters._T('Please enter card holder name')
      }

      commit('SET_CARD_ERRORS', errors)
    },
    async createSimplifyCardToken({ state, getters, dispatch, commit }) {
      const process = 'simplifyCardToken'

      if (getters.processInProgress(process)) {
        return Promise.reject('process already in progress')
      }

      return new Promise((resolve, reject) => {
        dispatch('startProcess', {
          process: process,
          progress: true,
        })
        let card = { ...state.cardModel }
        card.number = card.number.replace(/-/g, '')

        SimplifyCommerce.generateToken(
          {
            key: state.simplifyPublicApiKey,
            card: card,
          },
          data => {
            // Remove all previous errors
            // Check for errors

            if (data.error) {
              let errors = {}
              // Show any validation errors
              if (data.error.code == 'validation') {
                var fieldErrors = data.error.fieldErrors,
                  fieldErrorsLength = fieldErrors.length
                for (var i = 0; i < fieldErrorsLength; i++) {
                  errors[fieldErrors[i].field] = fieldErrors[i].message
                }
              } else if (data.error.code == 'system') {
                errors = {
                  message: data.error.message,
                }
              }

              const errorString = Object.keys(errors).reduce((err, key) => {
                return err ? ', ' : '' + errors[key]
              }, '')

              dispatch('showNotification', {
                text: errorString,
                status: 'error',
              })
              reject(errorString)
              dispatch('stopProcess', process)
            } else {
              //  The token contains id, last4, and card type
              commit('SET_CARD_TOKEN', data['id'])
              let card_number = { ...state.cardModel }
              let md5NewCard = md5(card_number.number)
              // let saved_card = localStorage.getItem('saved_card')
              let checkSavedCard = getters.customer_credit_cards.find(
                card => card.card_number === md5NewCard
              )
              // let card_already_saved = saved_card !== md5NewCard

              commit('SAVED_CARD_STATUS', checkSavedCard)
              // console.log(md5NewCard, checkSavedCard, saved_card, card_already_saved, 'card')
              if (state.isSaveCard && !checkSavedCard) {
                dispatch('saveSimplifyCard')
                  .then(response => {
                    if (response.status == 'ok') {
                      commit('ADD_NEW_CREDIT_CARD', response.card)
                      // localStorage.setItem('saved_card', md5NewCard)
                      //fetch customer again to reshow new cards,
                      //customer load api is calling almost 10 other places so we can't rely on state
                      dispatch('load_customer', true).finally(() => {
                        resolve()
                      })
                    } else {
                      dispatch('showNotification', {
                        text: response.error,
                        status: 'error',
                      })
                      dispatch('stopProcess', process)
                      reject()
                    }
                  })
                  .catch(error => {
                    dispatch('showNotification', {
                      text: error,
                      status: 'error',
                    })
                    dispatch('stopProcess', process)
                    reject()
                  })
                  .finally(() => {
                    dispatch('stopProcess', process)
                  })
              } else {
                //we are not saving customer card
                resolve()
                dispatch('stopProcess', process)
              }
            }
          }
        )
      })
    },
    async saveSimplifyCard({ getters, state }) {
      let card_number = { ...state.cardModel }
      let md5Card = md5(card_number.number)
      return new Promise((resolve, reject) => {
        axios
          .post(getters.save_card_api_url, {
            card_token: state.cardToken,
            card_number: md5Card,
          })
          .then(response => {
            if (response.data.error) {
              reject(response.data.error)
            } else if (response.data.status == 'ok') {
              resolve(response.data)
            }
          })
          .catch(error => reject(error))
      })
    },
    async deleteSimplifyCard({ getters }, cardId) {
      const deleteCustomerCardUrl =
        getters.delete_card_api_url +
        `id/${cardId}/delete?parent_id=${getters.web_user.id}`
      return new Promise((resolve, reject) => {
        axios
          .post(deleteCustomerCardUrl)
          .then(response => {
            if (response.data.error) {
              reject(response.data.error)
            } else if (response.data.status == 'ok') {
              resolve(response.data)
            }
          })
          .catch(error => reject(error))
      })
    },
    resetPayment({ commit, dispatch }) {
      commit('CASHBACK_ON_TRANSACTION', undefined)
      commit('USER_CHANGE_LOYALTY', 0)

      /*reset customer loyalty*/
      // let details = {currency: getters.currentStore.currency, customer_id: getters.userId}
      dispatch('load_customer', true)
    },
    removeCoupon({ commit }) {
      commit('SET_COUPON_DISCOUNT', undefined)
    },
    async applyCoupon({ getters, commit }) {
      //reset coupon
      return new Promise((resolve, reject) => {
        axios
          .get(getters.find_coupon_code_url(getters.coupon_code))
          .then(response => {
            //to simulate a delay we call it in api
            db.setStore('store')
            db.find('couponDiscount').then(data => {
              if (!response.data || !response.data.data) {
                return reject(
                  'Sorry! Something went failed, please try again later'
                )
              }
              if (!response.data.data.length) {
                return reject(`Sorry! Coupon code is not available`)
              }
              const discount = response.data.data[0]
              if (
                data &&
                data.discounts.find(
                  idiscount => idiscount.coupon_code == discount.coupon_code
                  // &&
                  // idiscount.name == discount.name &&
                  // idiscount.until_date + ' ' + idiscount.until ==
                  //   discount.until_date + ' ' + discount.until &&
                  // idiscount.from_date + ' ' + idiscount.from ==
                  //   discount.from_date + ' ' + discount.from
                )
              ) {
                reject('Sorry! coupon code has been already used')
              } else {
                //if discount available
                if (getters.availabeByTime(discount)) {
                  //check if coupon is applicable
                  let errors = { error: '' }
                  if (getters.validate_discount(discount, errors)) {
                    commit('SET_COUPON_DISCOUNT', discount)
                    resolve(discount)
                  } else {
                    reject(`Discount can not be applied. ${errors.error}.`)
                  }
                } else {
                  commit('SET_COUPON_DISCOUNT', undefined)
                  reject(`Sorry! coupon code is expired`)
                }
              }
            })
          })
          .catch(error => {
            reject(error)
            commit('SET_COUPON_DISCOUNT', undefined)
          })
      })
    },
    markCustomerUsedCoupon({ dispatch, getters }) {
      if (!getters.coupon_discount) {
        return false
      }
      //save customer used coupon
      db.setStore('store')
      db.find('couponDiscount').then(result => {
        let discounts = []
        if (result && result.discounts) {
          discounts = result.discounts
        }
        let discount = { ...getters.coupon_discount }
        discount.usage_time = utils.date_time_utc()
        discounts.push(discount)
        db.update({
          key: 'couponDiscount',
          discounts: discounts,
        }).then(() => {
          dispatch('resetCoupon')
        })
      })
    },
    resetCoupon({ commit }) {
      commit('SET_COUPON_DISCOUNT', undefined)
      commit('SET_COUPON_CODE', '')
    },
    revertCouponCode({ commit }, orderData) {
      if (orderData && orderData.order_discounts.length) {
        db.setStore('store')
        db.find('couponDiscount').then(result => {
          if (result && result.discounts) {
            let discounts = result.discounts.filter(
              discount =>
                discount._id ==
                orderData.order_discounts.filter(
                  orderdiscount => orderdiscount._id == discount._id
                )
            )
            db.update({
              key: 'couponDiscount',
              discounts: discounts,
            }).then(() => {})
          }
        })
      }
    },
  },
  mutations: {
    SET_CARD_TOKEN: (state, token) => (state.cardToken = token),
    SAVED_CARD_STATUS: (state, checkSavedCardStatus) =>
      (state.checkSavedCardStatus = checkSavedCardStatus),
    SET_CARD_MODEL: (state, cardModel) => {
      if (!cardModel) {
        state.cardModel = {
          expMonth: '01',
          expYear: new Date()
            .getFullYear()
            .toString()
            .substr(-2),
          cvc: '',
          number: '',
          name: '',
        }
      } else {
        state.cardModel = cardModel
      }
    },
    SELECT_PAYMENT_METHOD: (state, method) =>
      (state.selectedPaymentMethod = method),
    ADD_NEW_CREDIT_CARD: (state, card) => {
      state.currentCard = card
    },
    IS_SAVE_CARD: (state, option) => (state.isSaveCard = option),
    LOYALTY_INFORMATION: (state, information) =>
      (state.loyalty_information = information),
    USER_CHANGE_LOYALTY: (state, user_loyalty) =>
      (state.user_change_loyalty = user_loyalty),
    SET_CARD_ERRORS: (state, errors) => (state.cardErrors = errors),
    CLEAR_CARD_ERRORS: state =>
      (state.cardErrors = {
        expMonth: '',
        expYear: '',
        cvc: '',
        number: '',
        name: '',
      }),
    CASHBACK_ON_TRANSACTION: (state, status) =>
      (state.cashbackOnTransaction = status),
    SET_GUEST_CHECKOUT: (state, status) => (state.guestCheckout = status),
    SET_GUEST_INFO: (state, guestInfo) => (state.guestInfo = guestInfo),
    SET_COUPON_CODE: (state, code) => (state.couponCode = code),
    SET_COUPON_DISCOUNT: (state, discount) => (state.couponDiscount = discount),
  },
}
